import React from 'react';
import { getDate } from '../../../../../utils/dateUtils';

export default function AccountBasicDetailsCard({ accountDetails }) {
	return (
		<div className="bg-white px-4 p-2 mx-4 my-3 rounded-4">
			<div className="d-flex flex-wrap gap-4 align-items-center">
				<div className='px-1'>
					<div className="fs-4 font-medium text-black">Closing Balance</div>
					<div className="fs-5 font-small text-black">{`₹ ${accountDetails.closing_balance || 0}`}</div>
					<div className="fs-5 font-small text-black">{`As on ${''}`}</div>
				</div>
				<div className="account-divider"></div>
				<div className='px-3'>
					<div className="fs-4 font-medium text-black">Status</div>
					<div
						className="fs-5 font-small px-3 py-2 rounded-2"
						style={{
							color: `${accountDetails?.status === 0 ? '#FF0000' : '#68C230'}`,
							backgroundColor: `${accountDetails?.status === 0 ? '#FCE3DF' : '#F0FFE6'}`,
						}}
					>
						{accountDetails?.status === 0 ? 'Inactive' : 'Active'}
					</div>
				</div>
				<div className="account-divider"></div>
				<div className='px-1'>
					<div className="fs-4 font-medium text-black">Account Code</div>
					<div className="fs-5 font-small text-black">{accountDetails?.account_code || '-'}</div>
				</div>
				<div className="account-divider"></div>
				<div className='px-1'>
					<div className="fs-4 font-medium text-black">Account Type</div>
					<div className="fs-5 font-small text-black">{accountDetails?.account_type}</div>
				</div>
				<div className="account-divider"></div>
				<div className='px-1'>
					<div className="fs-4 font-medium text-black">Category</div>
					<div className="fs-5 font-small text-black">{accountDetails?.category}</div>
				</div>
				<div className="account-divider"></div>
				<div className='px-4'>
					<div className="fs-4 font-medium text-black">Created On</div>
					<div className="fs-5 font-small text-black">{getDate(accountDetails?.created_at)}</div>
				</div>
				<div className="account-divider"></div>
				<div className='px-1'>
					<div className="fs-4 font-medium text-black">Last Updated On</div>
					<div className="fs-5 font-small text-black">{getDate(accountDetails?.updated_at)}</div>
				</div>
			</div>
		</div>
	);
}
